import React from 'react';

import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function PaginatedTableColumns(props) {

    const { open, columns, viewableColumns, onToggleColumn, onToggleAllColumns, onClose } = props;

    const allOn = (viewableColumns.length === columns.length);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="table-columns-dialog-title"
            >
            <DialogTitle id="table-columns-dialog-title">
                <Grid container justifyContent='space-between' alignItems='center'>
                    <Grid item>Columns</Grid>
                    <Grid item>
                        <Button color='primary' onClick={onToggleAllColumns}>{allOn ? 'All Off' : 'All On'}</Button>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <FormControl component="fieldset">
                    <FormGroup>
                        {columns.map(option => {
                            if (option.type !== 'notify') return (
                                <FormControlLabel
                                    key={option.id}
                                    control={
                                        <Switch
                                            checked={viewableColumns.indexOf(option.id) > -1}
                                            onChange={onToggleColumn}
                                            value={option.id}
                                            color="primary"
                                        />
                                    }
                                    label={option.label}
                                />
                            );
                        })}
                    </FormGroup>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}
